import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { fromStore } from '../../../../selectors';
import { checkTimeWorkZone, getTimeWork } from '../../../../utils';
import { setOrderDeliveryZone, setOrderDeliveryZoneData } from '../../../../actions';

export function ErrorBlock() {
  const errors = useSelector(fromStore.orderErrorsSelector);
  const deliveryMethod = useSelector(fromStore.orderDeliveryMethodSelector);
  const timeMethod = useSelector(fromStore.orderDeliveryTimeMethodSelector);
  const selectedTime = useSelector(fromStore.orderDeliveryTimeSelector);
  const point = useSelector(fromStore.orderDeliveryPointSelector);
  const zoneData = useSelector(fromStore.orderDeliveryZoneDataSelector);
  const zonesData = useSelector(fromStore.orderDeliveryZonesDataSelector);
  const city = useSelector(fromStore.selectedCitySelector);
  const dispatch = useDispatch();

  const [timeWork, setTimeWork] = useState({ isWork: true, message: '' });

  useEffect(() => {
    const getZoneTimeWorkData = async () => {
      if (deliveryMethod === 'delivery' && zonesData && zoneData) {
        const checkZone = await checkTimeWorkZone({
          city,
          timeMethod,
          selectedTime,
          zoneData,
          zonesData,
        });

        if (checkZone.id !== zoneData.id) {
          dispatch(setOrderDeliveryZone(checkZone.id));
          dispatch(setOrderDeliveryZoneData(checkZone));
        }
      }
    };

    getZoneTimeWorkData();
  }, [deliveryMethod, zonesData, zoneData, timeMethod, selectedTime, dispatch]);

  useEffect(() => {
    const getTimeWorkData = async () => {
      const result = await getTimeWork({
        city,
        delivery: deliveryMethod,
        timeMethod,
        selectedTime,
        point,
        zoneData,
      });

      setTimeWork(result);
    };

    getTimeWorkData();
  }, [city, deliveryMethod, timeMethod, selectedTime, point, zoneData]);

  if (isEmpty(errors) && timeWork.isWork) return null;

  return (
    <div className="alert alert-danger d-flex align-items-center p-5">
      <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="currentColor" />
          <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="currentColor" />
        </svg>
      </span>
      <div className="d-flex flex-column">
        <span>{errors.adress || errors.point || errors.deliveryMethod || timeWork.message}</span>
      </div>
    </div>
  );
}
